/*
change 'closed' to status and allow multiple statuses like received, in process, closed, issue

need a public page that offers links to all public requests

add a setting to templates to remove the request from the listing page

when a form is created, make it so it's editable on our end. 
there should be a field so we can say who gets emailed when this form is submitted. 
if we want to do an r&d production request, maria would get the email
*/

import { GlobalContext } from 'components/GlobalContext';
import { IShortenedUrlInitResult } from 'models/IShortenedUrlInitResult';
import { useContext, useEffect, useRef, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import ShortenedUrlService from 'services/ShortenedUrlService';
import ShortenedUrlsLookup from './Lookup';

import './styles/ShortenedUrls.scss';

const ShortenedUrlsIndex = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [baseData, setBaseData] = useState<IShortenedUrlInitResult | undefined>();

    useEffect(() => {
        (async () => {
            globalContextRef.current.setLoading(true);
            const accessToken = await globalContextRef.current.getAccessTokenAsync();
            const result = await ShortenedUrlService.GetInitAsync(accessToken);

            if (result) {
                setBaseData({
                    ...result
                });
            }

            globalContextRef.current.setLoading(false);
        })();
    }, []);

    if (!baseData) {
        return (
            <>
            </>
        );
    }

    return (
        <>
            <div>
                <Routes>
                    <Route path={"Lookup/:page"} element={<ShortenedUrlsLookup baseData={baseData} />} />
                    <Route path={"Lookup"} element={<ShortenedUrlsLookup baseData={baseData} />} />
                    <Route path={"/*"} element={<ShortenedUrlsLookup baseData={baseData} />} />
                </Routes>
            </div>
        </>
    );
}

export default ShortenedUrlsIndex;
